import React, { FC } from 'react';
import { useIntl } from 'react-intl';
import { useDispatch } from 'react-redux';

import { Button } from 'antd';

import { logout } from '../../modules/client/actions/Client';
import AiIcon from '../AiIcon';

import { AppDispatch } from '../../types/app';

const Logout: FC = () => {
  const dispatch = useDispatch<AppDispatch>();
  const intl = useIntl();

  return (
    <Button
      type="text"
      className="btn-logout"
      onClick={() => {
        void dispatch(logout());
      }}
    >
      <AiIcon name="logout" />
      {intl.formatMessage({
        id: 'button.logout',
      })}
    </Button>
  );
};

export default Logout;
